// src/App.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Rankings from "./components/Rankings";
import AdminDashboard from "./components/AdminDashboard";
import Login from "./components/Login";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Rankings />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return user ? <>{children}</> : <Navigate to="/login" />;
};

export default App;